<template>

  <div style="height:96vh;">

    <div class="box__header">

        <form class="form form--inline" >
          <div>
            <label> Select tour </label>
                <v-select
                  v-if="tours !== null"
                  v-model="selectedTour"
                  label="name"
                  class="v-select--medium"
                  :options="tours"
                  placeholder="Filter by tour"
                  @change="onChangeTour"
                  
                >
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!selectedTour"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>

            <div class="ml-1">
                <label for="checkbox">Show suppressed?</label>
                <label class="switch">
                    <input id="checkbox" type="checkbox" v-model="suppressedFlag" v-on:change="getTours" />
                    <span class="switch__slider"></span>
                </label>
            </div>

            <div class="ml-1">
                <label>Departure Airport
                    <v-select
                      v-if="airports"
                      label="airport_name"
                      :options="airports"
                      v-model="selectedDepartureAirport"
                      placeholder="Filter by departure airport"
                      
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.iata_code }} - {{ option.airport_name }}
                      </template>
                    </v-select>
                </label>
            </div>

            <div>
                <label for="d-from-date">Departure From Date</label>
                <input id="d-from-date" type="date" v-model="departureFromDate" />
            </div>

            <div>
                <label for="d-to-date">Departure To Date</label>
                <input id="d-to-date" type="date" v-model="departureToDate" />
            </div>
            
            <div class="ml-1">
              <button type="button" class="button button--small" v-if="selectedTour !== null" v-on:click="getTourInstances">Search</button>
            </div>
        </form>

    </div>

    <table class="table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>Departure date</th>
          <th>Departing from</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="selectedTour !== null && selectedTourInstances.length > 0">
        <template v-for="instance of selectedTourInstances">
          <tr :key="instance.id + '-instance'" :style="((instance.is_special_instance || instance.group.is_special_group) ? 'background: #e8e8e8' : null)">
            <td>{{ instance.departure_date | formatDate }}</td>
            <td v-if="instance.airport">
              <span>
                {{ instance.airport.airport_name }} ({{ instance.airport.iata_code }})<br>
              </span>
              <div v-if="instance.instance_title">
                <small>[{{ instance.instance_title }}]</small> <br>
              </div>
              <small v-for="flight of instance.flights" :key="flight.id">
                {{ flight.flight_number }} {{ flight.departure_airport.iata_code }} &rarr; {{ flight.arrival_airport.iata_code }} {{ flight.departure_time | formatDateTime }}<br>
              </small>
            </td>
            <td v-else-if="instance.pick_up_point">
              {{ instance.pick_up_point.pickup_point_name }}
            </td>
            <!-- <td class="table-action"><button v-on:click="expandedInstance = instance.id">Expand</button></td> -->
            <td class="table-action"><button v-on:click="fetchInstanceRooms(instance.id,instance.departure_date)">Expand</button></td>
          </tr>
          <tr :key="instance.id + '-accommodation'" v-if="expandedInstance == instance.id">
            <td colspan="3">
              <table class="table" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <th>Hotel</th>
                    <th>Room</th>
                    <th>Rooms Available</th>
                    <th>Board basis</th>
                    <th>Price (pp)</th>
                    <th>Duration (of {{ instance.duration || instance.group.duration || selectedTour.duration }})</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                <template v-if="selectedInstancePrice.length > 0 ">
                  <tr v-for="option of selectedInstancePrice" :key="option.id">
                    <td>{{ option.room.accommodation.details.accommodation_name }}</td>
                    <td>{{ option.room.name }}</td>
                    <td>
                      <template v-if="option.room_availability.remaining_availability > 0 ">
                        {{ option.room_availability.remaining_availability }}
                      </template>
                      <template v-else> <span class="text-danger">Unavailable</span></template>
                    </td>
                    <td>{{ option.room.board_basis }}</td>
                    <td v-if="option.sale_price"><del>{{ option.room_new_addjusted_price | formatCurrency }}</del> {{ option.sale_price | formatCurrency }}</td>
                    <td v-else>{{ option.room_new_addjusted_price | formatCurrency }}</td>
                    <td>{{ option.room.accommodation.check_in_day }} - {{ option.room.accommodation.check_out_day }}</td>
                    <td class="table-action">
                      <template v-if="option.room.accommodation_room.is_multiple">
                        <template v-if="option.room_availability.remaining_availability > 0">
                          <select v-on:change="selectRoom(option, instance, $event.target.value)">
                            <option value="">Select</option>
                            <option v-for="n in option.room.accommodation_room.multiple_rooms_description" :key="n.id" :value="n.description">{{ n.description }}</option>
                          </select>
                        </template>
                        <template v-else><button class="button button--small" disabled>Select</button></template>
                      </template>
                      <template v-else>
                        <template v-if="option.room_availability.remaining_availability > 0">
                          <button v-on:click="selectRoom(option, instance)" class="button button--small">Select</button>
                        </template>
                        <template v-else><button class="button button--small" disabled>Select</button></template>
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="7">
                      <h6 class="text-center">No Rooms Avialable</h6>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

  </div>

</template>

<script>
import moment from 'moment';

export default {
  name: 'BookingTourSelect',
  props : {
    booking: Object,
  },
  data () {
    return {
      selectedTour: null,
      selectedTourInstances: [],
      selectedTourInstance: null,
      selectedDepartureAirport: null,
      expandedInstance: null,
      suppressedFlag: null,
      departureFromDate: '',
      departureToDate: '',
      airports: null,
      tours: null,
      selectedInstancePrice: []
    }
  },
  created: function() {
    this.getTours()
    this.getAirports()
  },
  methods: {
    onChangeTour() {
      this.getAirports()
    },
    getAirports () {
      this.$store.dispatch('setLoadStatus')
      let qs = [];
      if (this.selectedTour !== null){
        qs.push("selectedTour=" + this.selectedTour.id)
      }

      fetch(this.$api + 'airports/by_country/GB?' + qs.join('&'), {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.airports = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    getTours () {
      this.$store.dispatch('setLoadStatus')
      let qs = [];
      if (this.suppressedFlag == true){
        this.suppressedFlag = 1
        qs.push("show_suppressed=" + this.suppressedFlag)
      }
        
      fetch(this.$api + 'tours?' + qs.join('&'), {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.selectedTourInstances = []
        this.selectedTour = null

        this.tours = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    getTourInstances () {
      if(this.selectedTour !== null) {
        this.getAirports()
        let qs = []
        if (this.selectedDepartureAirport !== null){
            qs.push("DepartureAirport=" + this.selectedDepartureAirport.id)
        }

        if (this.departureFromDate !== ''){
            qs.push("departureFromDate=" + this.departureFromDate)
        }
        
        if (this.departureToDate !== ''){
            qs.push("departureToDate=" + this.departureToDate)
        }
        
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'tours/' + this.selectedTour.id + '/instances?' + qs.join('&'), {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.selectedTourInstances = response.data
          this.$store.dispatch('setLoadStatus')

          this.selectedTourInstances.forEach((element, index) => {
            // Only show the non excluded accommodation
            let accommodation = element.prices.filter(accommodation => {
              return !element.group.excluded_accommodations.some(excluded_accommodation => {
                return (
                  excluded_accommodation.accommodation_id === accommodation.room.accommodation.accommodation_id &&
                  excluded_accommodation.tour_accommodation_id === accommodation.room.tour_accommodation_id
                );
              });
            });
            
            this.selectedTourInstances[index].prices = accommodation
          })

        })

      }
    },
    fetchInstanceRooms(instance_id,departure_date) {
      this.handleBookingTour(`${this.$api}tours/get-instance-rooms`, { instance_id, departure_date:  moment(departure_date).format('YYYY-MM-DD') })
        .then((response) => {
            this.selectedInstancePrice = response.data
            this.expandedInstance = instance_id
          })
    },
    selectRoom (option, instance, selectedValue=null) {
        let savingUrl = `${this.$api}update-booking/${this.$route.params.id}/update-tours`
        let This = this
        option.tour = This.selectedTour
        if (!this.$route.params.id) {
          option.tour = This.selectedTour
          option.instance = instance
          This.selectedTourInstances = instance
          This.$set(option, 'id', null)
          This.$set(option, 'special_requests', null)
          This.$set(option, 'passengers', null)
          if(option.rooms == null) This.$set(option, 'rooms', 1)
          if(option.guests == null) This.$set(option, 'guests', option.room.occupancy)
          This.$set(option, 'price', option.room_new_addjusted_price)
          if(option.sale_price !== null) This.$set(option, 'price', option.sale_price)
    
          if (This.booking.tour_bookings.includes(option) === false) {
            let newOption = {
              ...option,
              selected_multiple_room: selectedValue
            }
            This.booking.tour_bookings.push(newOption)
            This.$parent.selectingTours = false
          }

        }else{
          let body_params = {
            id: null,
            tour_id: option.tour.id,
            tour_instance_id: option.tour_instance_id,
            tour_room_id: option.tour_room_id,
            selected_multiple_room:selectedValue,
            rooms: 1,
            guests: option.room.occupancy,
            price: (option.sale_price !== null) ? option.sale_price : option.room_new_addjusted_price,
            base_price: option.base_price,
            supplement_price: option.supplement_price,
            cost: option.cost,
            airline_ref: option.airline_ref,
            passengers: null,
            special_requests: null,
            airline_ref_added_at: option.airline_ref_added_at,
            airline_flight_cost: option.airline_flight_cost,
            departure_date: instance.departure_date
          } 

          this.handleBookingTour(savingUrl, body_params)
              .then((response) =>{
                if (response.status) {
                  option.tour = This.selectedTour
                  option.instance = instance
                  This.selectedTourInstances = instance
                  This.$set(option, 'id', null)
                  This.$set(option, 'special_requests', null)
                  This.$set(option, 'passengers', null)
                  if(option.rooms == null) This.$set(option, 'rooms', 1)
                  if(option.guests == null) This.$set(option, 'guests', option.room.occupancy)
                  This.$set(option, 'price', option.adjusted_price)
                  if(option.sale_price !== null) This.$set(option, 'price', option.sale_price)
            
                  if (This.booking.tour_bookings.includes(option) === false) {
                    option.selected_multiple_room = selectedValue
                    This.booking.tour_bookings.push(option)
                    This.$parent.selectingTours = false
                  }
                  
                  This.booking.balance_due = response.updated_balance_due_date
                  This.$emit('updateBookingHistory')
                }
              }).catch((error) => {
                console.log(error);
              })
        }
    },
    handleBookingTour(url, body_parameters) {
      this.$store.dispatch('setLoadStatus')
      return new Promise((resolve, reject) => {
        fetch(url, {
          method: 'POST',
          body: JSON.stringify(body_parameters),
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          resolve(response)          
        })
        .catch((error) => {
          this.$store.dispatch('setLoadStatus')
          reject(error)
        })
      })
    }
    
  }
}
</script>

<style scoped>
.row-blur {
  filter: blur(3px);
}
</style>

